<template>
  <section class="cases">
    <div class="section-wrap">
      <Header :trigger="trigger"/>
    </div>
    <div class="container">
      <h1 class="promo__head">i feel blessed with my work both digital and physical products taking them from idea to app store and shop shelves</h1>
      <p class="promo__text">here is a short example of the diverse list of experiences - working with passionated people</p>
      <section class="cases__cases about__split">
        <div>
            <a class="link" href="https://accelerator.plusimpact.io/">
              <h2>Katapult - accelerator</h2>
            </a>
            <p class="cases__list__case__text">Co-facilitator with the +impact program run by Danske Bank in Copenhagen. Aleksander was the local facilitator responsible for planning and executing entrepreneurial workshops.</p>
        </div>
        <div>
          <a class="link" href="http://communities.techstars.com/denmark/copenhagen/">
            <h2>Techstars - Startup Weekend</h2>
          </a>
          <p class="cases__list__case__text">Being the community leader of the world phenomenon Startup Weekend, where you take ideas into mvp in just 54 hours. Aleksander has strong experience with planning and insights into the start process.</p>
        </div>
        <div>
          <a class="link" href="https://cphdot.dk/">
            <h2>Cph Dot - biz dev</h2>
          </a>
          <p class="cases__list__case__text">Coming with experience of bringing multiple ideas into production and developing new digital strategies. Including how to utilise crowdfunding in preselling your idea.</p>
        </div>
        <div>
          <a class="link" href="https://norvai.com/">
            <h2>Norvai - innovations agency</h2>
          </a>
          <p class="cases__list__case__text">With a foundation in community and innovation. Aleksander has developed a framework for communication about your community relevant for both internal and external stakeholders.</p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'Aleksander',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Cases/Aleksander.vue